import { ListingSubtype, TransactionMode, type Listing } from 'app/types/listing';

type ListingTransactionFields = Partial<Pick<Listing, 'isDonation' | 'subtype' | 'transactionMode'>>;

export function isDonationListing(listing?: ListingTransactionFields | null) {
  if (!listing) return false;
  if (listing.transactionMode) return listing.transactionMode === TransactionMode.give;
  return listing.isDonation === true || listing.subtype === ListingSubtype.donation;
}

export function getListingTransactionMode(listing?: ListingTransactionFields | null): TransactionMode {
  if (listing?.transactionMode) return listing.transactionMode;
  return isDonationListing(listing) ? TransactionMode.give : TransactionMode.lend;
}

export function isDeletable(listing: Pick<Listing, 'status'>): listing is Listing & {
  status: Exclude<Listing['status'], 'deleted'>;
} {
  return listing.status !== 'deleted';
}

export function isListingAvailabilityRangeValid(start?: string | null, end?: string | null) {
  return !start || !end || new Date(end).getTime() >= new Date(start).getTime();
}
